import { translate } from "../../util/translate"

translate['city.label.status']

export const headers = [
  {
    text: translate['dispute.table.headers.code'],
    value: 'jobCode',
    width: 80,
  },
  {
    text: translate['dispute.table.headers.type'],
    value: 'type',
    width: 150,
  },
  {
    text: translate['dispute.table.headers.realty'],
    value: 'assetCode',
    width: 400,
  },
  {
    text: translate['dispute.table.headers.host'],
    value: 'host',
    width: 300,
  },
  {
    text: translate['dispute.table.headers.createdAt'],
    value: 'createdDate',
    width: 150,
  },
  {
    text: translate['dispute.table.headers.status'],
    value: 'status',
    width: 100,
  },
  {
    text: translate['dispute.table.headers.items'],
    value: 'pendingItemsQuantity',
    width: 165,
  },
  {
    text: translate['dispute.table.headers.sla'],
    value: 'slaRemainingMinutes',
    sortable: false,
    align: 'center',
    width: 60,
  },
  {
    text: translate['dispute.table.headers.owner'],
    value: 'ownerType',
    sortable: false,
    align: 'center',
    width: 130,
  },
  { value: 'actions', align: 'end', width: 65 }
]
